import { type ComponentProps, memo, useMemo } from 'react';

import { PERCENT_SCALE } from '@air/utilities';
import { cn } from '@air/utils-tailwind';

import { usePlayerStore } from './PlayerContextProvider';

export type PlayerSeekbarTrackProps = Pick<ComponentProps<'div'>, 'className'>;

export const PlayerSeekbarTrack = memo(({ className }: PlayerSeekbarTrackProps) => {
  const currentTime = usePlayerStore((state) => state.currentTime);
  const duration = usePlayerStore((state) => state.duration);

  const progress = useMemo(() => {
    const percentage = (currentTime / duration) * PERCENT_SCALE;

    if (Number.isNaN(percentage)) {
      return 0;
    }

    return currentTime >= duration ? PERCENT_SCALE : percentage;
  }, [currentTime, duration]);

  return (
    <div className={cn('relative w-full', className)} data-progress={progress} data-testid="PLAYER_SEEKBAR_TRACK">
      <div className="h-1 overflow-hidden rounded-4 ads:bg-input bg-gray-7">
        <div
          className="size-full rounded-4 ads:bg-primary bg-blue-9"
          style={{ transform: `translateX(-${PERCENT_SCALE - progress}%)` }}
        />
      </div>
    </div>
  );
});

PlayerSeekbarTrack.displayName = 'PlayerSeekbarTrack';
